module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hf-box"
  }, [_c('div', {
    staticClass: "hf-content"
  }, [_c('div', {
    staticClass: "hf-video-wrap"
  }, [_c('video', {
    ref: "videoPlayer",
    staticClass: "hf-video",
    attrs: {
      "src": _vm.videoUrl
    },
    on: {
      "timeupdate": _vm.onTimeUpdate,
      "loadedmetadata": _vm.onLoadedMetadata,
      "ended": _vm.onEnded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hf-controls"
  }, [_c('div', {
    staticClass: "hf-controls-btn",
    on: {
      "click": _vm.togglePlay
    }
  }, [(_vm.isPlaying) ? _c('span', [_vm._v("❚❚")]) : _c('span', [_vm._v("▶")])]), _vm._v(" "), _c('span', {
    staticClass: "hf-controls-time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    ref: "progressBar",
    staticClass: "hf-controls-progress",
    on: {
      "click": _vm.seekVideo,
      "mousedown": _vm.onProgressMouseDown
    }
  }, [_c('div', {
    staticClass: "hf-controls-progress-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "hf-controls-progress-fill",
    style: ({
      width: _vm.progress + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "hf-controls-progress-dot",
    style: ({
      left: _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "hf-controls-time"
  }, [_vm._v(_vm._s(_vm.formatTime(_vm.duration)))]), _vm._v(" "), _c('div', {
    staticClass: "hf-controls-speed",
    on: {
      "click": _vm.toggleSpeed
    }
  }, [_vm._v(_vm._s(_vm.$t('all.beisu')) + " x" + _vm._s(_vm.playbackRate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hf-sidebar"
  }, [_c('div', {
    staticClass: "hf-sidebar-title"
  }, [_vm._v(_vm._s(_vm.$t('all.zhibojilu')))]), _vm._v(" "), _c('div', {
    staticClass: "hf-sidebar-list"
  }, _vm._l((_vm.replayList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.currentIndex === index ? 'hf-sidebar-item-active' : 'hf-sidebar-item',
      on: {
        "click": function($event) {
          return _vm.handleSwitchReplay(index)
        }
      }
    }, [_c('div', {
      staticClass: "hf-sidebar-item-cover",
      style: ({
        backgroundImage: 'url(' + item.backgroundUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "hf-sidebar-item-info"
    }, [_c('span', {
      staticClass: "hf-sidebar-item-info-title"
    }, [_vm._v(_vm._s(item.name) + " | " + _vm._s(item.period))]), _vm._v(" "), _c('span', {
      staticClass: "hf-sidebar-item-info-tag"
    }, [_vm._v(_vm._s(item.categoryName))]), _vm._v(" "), _c('span', {
      staticClass: "hf-sidebar-item-info-time"
    }, [_vm._v(_vm._s(item.liveStartTime) + " - " + _vm._s(item.liveEndTime))])]), _vm._v(" "), (item.isHot) ? _c('img', {
      staticClass: "hf-sidebar-item-hot",
      attrs: {
        "src": require("../../../assets/image/shanchu_18@2x.png"),
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "hf-sidebar-item-del",
      attrs: {
        "src": require("../../../assets/image/shanchu_18@2x.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleDelete(item, index)
        }
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c5b086a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/huifang/huifang.vue
// module id = 951
// module chunks = 1